const eCustomRemediationView = {
  CustomRemList: 1,
  CreateCustomRem: 2,
  EditCustomRem: 3,
  CreateApiCustomRem: 4,
  EditApiCustomRem: 5
};

export default eCustomRemediationView;
